"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllUserOnboardings = void 0;
const OnboardingId_1 = require("./OnboardingId");
const HodUserOnboarding_1 = require("../../hod/domain/HodUserOnboarding");
const HlUserOnboarding_1 = require("../../hl/domain/HlUserOnboarding");
const validator_1 = require("@leavy/validator");
const ddd_1 = require("../../infrastructure/ddd");
/**
 * All the onboardings started by the user
 */
class AllUserOnboardings extends ddd_1.AggregateRootBase {
    constructor(id, data) {
        super(id);
        this.initialize(data);
    }
    toPlain() {
        return { ...this };
    }
}
_a = OnboardingId_1.OnboardingId.HL, _b = OnboardingId_1.OnboardingId.HOD;
__decorate([
    (0, validator_1.Type)(() => HlUserOnboarding_1.HlUserOnboarding),
    __metadata("design:type", HlUserOnboarding_1.HlUserOnboarding)
], AllUserOnboardings.prototype, _a, void 0);
__decorate([
    (0, validator_1.Type)(() => HodUserOnboarding_1.HodUserOnboarding),
    __metadata("design:type", HodUserOnboarding_1.HodUserOnboarding)
], AllUserOnboardings.prototype, _b, void 0);
exports.AllUserOnboardings = AllUserOnboardings;
//# sourceMappingURL=AllUserOnboardings.js.map